/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

export const YEARS = 'years'
export const MONTHS = 'months'
export const DAYS = 'days'

const DurationUnits = [
  YEARS,
  MONTHS,
  DAYS
]

export default DurationUnits
